export default __webpack_public_path__ + "static/media/Pegasus3.a5f0c51e.png";